interface ISearchParams {
  [key: string]: string
}

export function parseSearchParams(search: string) {
  if (search) {
    return search
      .replace(/^\?/, '')
      .split('&')
      .reduce((params: ISearchParams, pair) => {
        const [key, value] = pair.split('=')

        if (!key) {
          return params
        }

        const decodedValue = decodeURIComponent(value)

        return {
          ...params,
          [key]: decodedValue,
        }
      }, {})
  }

  return {}
}
